<template>
    <div class="dashboard">
        <h1>車両{{ contents[contentsType].title }}</h1>
        <ValidationObserver ref="observer" v-slot="{ invalid }" tag="div">
            <div class="l-w5 l-2-20-t--all">
                <div>
                    <h2>車両ID</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="車両ID" rules="integer|max_value:9999|min_value:1|required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.vehicle_id" type="number" :disabled="contents[contentsType].flagDisabled">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                    <h2>車両No</h2>
                    <ValidationProvider v-slot="{ errors }" class="l-mt2 l-mb8" name="車両No" rules="regex:^([A-Za-z0-9-]*)$|max:30|required" tag="div" :immediate="$_getValidatedImmediate()">
                        <input v-model="input.vehicle_number" type="text">
                        <p class="errorMessage">{{ errors[0] }}</p>
                    </ValidationProvider>
                    <h2 >車両サイズ</h2>
                    <div class="l-mt2 l-mb8">
                        <select v-model="input.vehicle_size_id">
                            <option v-for="(data, key) in listVehiclesSize" :key="key" :value="data.vehicle_size_id">{{ data.vehicle_size_name }}</option>
                        </select>
                    </div>
                </div>
                <div class="is-left">
                    <h2>メインドライバー</h2>
                    <div class="l-mt2 l-mb8">
                        <select v-model="input.driver_id">
                            <option value="">選択してください。</option>
                            <option v-for="(data, key) in listDrivers" :key="key" :value="data.driver_id">{{ data.driver_name }}</option>
                        </select>
                    </div>
                    <h2>点検日</h2>
                    <div class="l-mt2 l-mb8">
                        <input v-model="input.inspection_date" type="date">
                    </div>
                    <h2>状態</h2>
                    <div class="l-mt2 l-mb8">
                        <input id="maintenance_flag" v-model="input.maintenance_flag" type="checkbox" true-value="1" false-value="0">
                        <label for="maintenance_flag">メンテナンス中</label>
                    </div>
                </div>
            </div>
            <div class="l-mt6 l-2-00-m--all">
                <div>
                    <button :class="`${classButtonStyle}cancel`" type="button" @click="$_goBack()">戻る</button>
                    <button :class="X_validatedButtonStyle" type="button" :disabled="$_setValidatedDisabled(invalid)" @click="$_modalOpen(contents[contentsType].modal)">次へ</button>
                </div>
                <div v-if="contents[contentsType].flagShow">
                    <button :class="`${classButtonStyle}delete`" type="button" @click="$_modalOpen('deleteVehicles')">削除する</button>
                </div>
            </div>
        </ValidationObserver>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    const contents = {
        "create": {
            "flagDisabled": false,
            "flagShow": false,
            "modal": "createVehicles",
            "title": "登録",
        },
        "update": {
            "flagDisabled": true,
            "flagShow": true,
            "modal": "updateVehicles",
            "title": "編集",
        },
    };

    export default {
        "mixins": [
            common,
        ],
        "props": {
            "id": {
                "default": "",
                "required": false,
                "type": String,
            },
        },
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "contents": contents,
                "contentsType": "create",
                "input": {
                    "vehicle_id": "",
                    "vehicle_number": "",
                    "vehicle_size_id": "",
                    "driver_id": "",
                    "maintenance_flag": "0",
                    "inspection_date": "",
                },
                "listDrivers": [],
                "listVehiclesSize": [],
                "sync": {
                    "drivers": "",
                    "vehiclesSize": "",
                },
            };
        },
        async created() {
            this.fetchingListDrivers();
            this.fetchingListVehiclesSize();
            if (this.id) {
                // 登録画面から編集画面へ切り替え
                const drivers = await this.sync.drivers;
                const vehiclesSize = await this.sync.vehiclesSize;
                this.contentsType = "update";
                this.fetchingDataVehicles(drivers, vehiclesSize);
            } else {
                this.$_setValidatedImmediate();
            }
        },
        "methods": {
            modalAction(key) {
                if (key === "createVehicles") {
                    this.handleCreate();
                } else if (key === "updateVehicles") {
                    this.handleUpdate();
                } else if (key === "deleteVehicles") {
                    this.handleDelete();
                } else if (key === "createVehicles--finished" || key === "updateVehicles--finished" || key === "deleteVehicles--finished") {
                    this.$router.push({ "name": "offices_vehicles_list" });
                }
            },
            setMainDriver() {
                // メインドライバーの存在確認
                let flag = false;
                for (let data of this.listDrivers) {
                    if (data.driver_id == this.input.driver_id) {
                        flag = true;
                        break;
                    }
                }
                if (!flag) {
                    this.input.driver_id = "";
                }
            },
            fetchingListDrivers() {
                // 全ドライバーデータ取得
                this.sync.drivers = common.$_axios.get(
                    `${common.$_configs.apiUrl}/drivers`,
                    this.$_requestConfig()
                ).then(response => {
                    // ドライバーIDで昇順
                    this.listDrivers = response.data.sort((a, b) => a.driver_id - b.driver_id);
                }).catch(() => {
                    this.$_modalError("fetchingDriversError");
                });
            },
            fetchingListVehiclesSize() {
                // 全車両サイズデータ取得
                this.sync.vehiclesSize = common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicles/size`,
                    this.$_requestConfig()
                ).then(response => {
                    // 車両サイズIDで昇順
                    this.listVehiclesSize = response.data.sort((a, b) => a.vehicle_size_id - b.vehicle_size_id);
                    if (!this.id) {
                        this.input.vehicle_size_id = this.listVehiclesSize[0].vehicle_size_id;
                    }
                }).catch(() => {
                    this.$_modalError("fetchingVehiclesSizeError");
                });
            },
            fetchingDataVehicles() {
                // 個別車両データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicles/${this.id}`,
                    this.$_requestConfig()
                ).then(response => {
                    this.input = response.data;
                    this.setMainDriver();
                }).catch(() => {
                    this.$_modalError("fetchingVehiclesError");
                });
            },
            handleCreate() {
                // 個別車両データ登録
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/vehicles`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            handleUpdate() {
                // 個別車両データ編集
                common.$_axios.post(
                    `${common.$_configs.apiUrl}/vehicles/${this.id}`,
                    this.input,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
            handleDelete() {
                // 個別車両データ削除
                common.$_axios.delete(
                    `${common.$_configs.apiUrl}/vehicles/${this.id}`,
                    this.$_requestConfig()
                ).then(() => {
                    this.$_modalFinished();
                }).catch(() => {
                    this.$_modalError();
                });
            },
        },
    };
</script>
